import { useNavigate } from 'react-router-dom';
import logo2 from '../../img/optionbricks_logo.png';

const Footer = () => {
  const navigate = useNavigate();

  // ✅ Reusable function for download + navigate
  const handleDownloadAndNavigate = (filePath, fileName, route) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      navigate(route);
    }, 500);
  };

  const quickLinks = [
    { label: "Home", href: "/" },
    { label: "About Us", href: "/about" },
    { label: "Service Offerings", href: "/service-offerings" },
    { label: "User Consent", href: "/user-consent" },
    { label: "Contact Us", href: "/contact" },
  ];

  const supportLinks = [
    { label: "Terms & Conditions", href: "/tandc" },
    { label: "Grievance Policy", href: "/grievance-policy" },
    { label: "Complaint Data", href: "/complaint-board" },
    { label: "Investor Charter", href: "/investor-charter" },
    { label: "Ad Disclaimer", href: "/ad-disclaimer" },
     { label: "Accessibility Statement", href: "/accessibility-statement" },
  { label: "Sitemap", href: "/sitemap" },
  ];

  const socials = [
    { icon: "fab fa-facebook-f", href: "#" },
    { icon: "fab fa-twitter", href: "#" },
    { icon: "fab fa-instagram", href: "#" },
    { icon: "fab fa-linkedin-in", href: "#" },
  ];

  return (
    <footer className="relative bg-[#1e6091] text-blue-100/80 font-sans overflow-hidden">
      {/* Top accent line */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>

      {/* Subtle texture */}
      <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:26px_26px] [mask-image:radial-gradient(ellipse_70%_60%_at_50%_0%,#000_50%,transparent_100%)] pointer-events-none"></div>

      <div className="relative container mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8">

          {/* ===== Brand ===== */}
          <div className="lg:col-span-4">
            <div className="inline-block bg-white rounded-2xl p-4 mb-6 shadow-[0_8px_30px_rgba(255,255,255,0.08)]">
              <img src={logo2} alt="Option Bricks" className="w-44 h-auto" />
            </div>
            <p className="text-[15px] leading-relaxed text-blue-50/90 max-w-sm">
              Option bricks offers insights and tailored strategies for
              navigating the financial markets. Our team is dedicated to
              providing you with the tools and knowledge you need to make
              informed investment decisions and achieve your financial goals.
            </p>

            {/* Socials */}
            {/* <div className="flex items-center gap-3 mt-8">
              {socials.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-white hover:bg-white hover:text-black hover:border-white hover:-translate-y-1 transition-all duration-300"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div> */}
          </div>

          {/* ===== Quick Links ===== */}
          <div className="lg:col-span-2">
            <h3 className="text-white text-xs font-bold uppercase tracking-[0.18em] mb-6 flex items-center gap-2">
              <span className="w-5 h-px bg-white"></span>
              Quick Links
            </h3>
            <ul className="space-y-3.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="group inline-flex items-center gap-2 text-[15px] font-medium text-blue-50/90 hover:text-white transition-colors duration-300"
                  >
                    <span className="w-0 group-hover:w-3 h-px bg-white transition-all duration-300"></span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ===== Support ===== */}
          <div className="lg:col-span-3">
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.18em] mb-6 flex items-center gap-2">
              <span className="w-5 h-px bg-white"></span>
              Support
            </h4>
            <ul className="space-y-3.5">
              {supportLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="group inline-flex items-center gap-2 text-[15px] font-medium text-blue-50/90 hover:text-white transition-colors duration-300"
                  >
                    <span className="w-0 group-hover:w-3 h-px bg-white transition-all duration-300"></span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ===== Contact ===== */}
          <div className="lg:col-span-3">
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.18em] mb-6 flex items-center gap-2">
              <span className="w-5 h-px bg-white"></span>
              Contact Info
            </h4>
            <ul className="space-y-4 text-[15px]">
              <li className="flex items-center gap-3">
                <span className="w-9 h-9 flex-shrink-0 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white">
                  <i className="fas fa-map-marker-alt text-sm"></i>
                </span>
                <span className="font-semibold text-white">Mumbai</span>
              </li>





              <li className="flex items-center gap-3">
  <span className="w-9 h-9 flex-shrink-0 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white">
    <i className="fas fa-envelope text-sm"></i>
  </span>
  
   <a href="mailto:compliance@optionbricks.in"
    className="font-semibold text-white break-all hover:underline transition-colors"
  >
    compliance@optionbricks.in
  </a>
</li>
<li className="flex items-center gap-3">
  <span className="w-9 h-9 flex-shrink-0 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white">
    <i className="fas fa-phone-alt text-sm"></i>
  </span>
  
   <a href="tel:+919082280240"
    className="font-semibold text-white hover:underline transition-colors"
  >
    +91 90822 80240
  </a>
</li>

              
            
              {/* <li className="flex items-center gap-3">
                <span className="w-9 h-9 flex-shrink-0 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white">
                  <i className="fab fa-firefox-browser text-sm"></i>
                </span>
                <span className="font-semibold text-white break-all">compliance@optionbricks.in</span>
              </li> */}
            </ul>

            {/* SEBI Compliance */}
            <div className="mt-7 bg-white/[0.04] border border-white/10 rounded-2xl p-5">
              <h5 className="text-white text-[10px] font-bold uppercase tracking-[0.22em] mb-3">
                SEBI Grievance / Address
              </h5>
              <p className="text-blue-50/80 text-xs leading-relaxed mb-4">
                PN-C/7, G Block BKC, Bandra Kurla Complex, <br />
                Bandra East, Mumbai, Maharashtra 400051
              </p>
              <a
                href="https://scores.sebi.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-white text-black text-xs font-bold px-4 py-2 rounded-full hover:bg-gray-200 transition-colors"
              >
                SEBI SCORES <i className="fas fa-external-link-alt text-[9px]"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Disclaimer ===== */}
      <div className="relative border-t border-white/10">
        <div className="container mx-auto px-6 lg:px-12 py-8">
          <h5 className="text-white text-sm font-bold uppercase tracking-[0.22em] mb-4">
            Disclaimer
          </h5>
          <p className="text-blue-50/90 text-sm sm:text-[15px] leading-relaxed text-justify">
            Investments in securities are subject to{" "}
            <span className="font-semibold text-white">market fluctuations</span>,
            meaning the value of your investment can go up or down depending on
            various factors affecting the securities market. The{" "}
            <span className="font-semibold text-white">
              SEBI registration, Enlistment with RAASB, and NISM certification do
              not guarantee the performance of the RA or assure any returns
            </span>{" "}
            to the client. The recommendations provided by Option Bricks{" "}
            <span className="font-semibold text-white">
              do not provide any assurance of returns
            </span>
            . Any investment made based on recommendations in research reports are{" "}
            <span className="font-semibold text-white">subject to market risks</span>,
            and recommendations do not provide any assurance of returns.{" "}
            <span className="font-semibold text-white">
              There is no recourse to claim any losses
            </span>{" "}
            incurred on the investments made based on the recommendations in the
            research report. Any reliance placed on the research report provided by
            Option Bricks shall be as per the{" "}
            <span className="font-semibold text-white">
              client's own judgement and assessment
            </span>{" "}
            of the conclusions contained in the research report. Please refer SEBI
            circular number{" "}
            <span className="font-semibold text-white">
              SEBI/HO/MIRSD/MIRSD-PoD/P/CIR/2025/20 dated February 17, 2025
            </span>{" "}
            for further details.
          </p>
        </div>
      </div>

      {/* ===== Bottom bar ===== */}
      <div className="relative border-t border-white/10">
        <div className="container mx-auto px-6 lg:px-12 py-7 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-medium text-blue-100/80">
            © {new Date().getFullYear()} <span className="text-white font-bold">Option Bricks</span>. All rights reserved.
          </p>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-white">
            Research-Backed Market Advisory
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
